document.addEventListener('DOMContentLoaded', function () {
    let simGouwSection = document.getElementById("shopify-section-template--17069138608239__video_hero_QgCk4K");
    let videoHeroThumbWrapper = document.querySelectorAll(".thumbnail-wrapper");
    let videoHeroContentOverlay = document.querySelectorAll(".video-hero__content > .content-overlay");
    let videoHeroContent = document.querySelectorAll(".video-hero:has(.thumbnail-wrapper) .video-hero__content-wrapper");
    let videoEl;

    // Video thumbnail functionality
    videoHeroThumbWrapper.forEach(function(thumbnail) {
        thumbnail.addEventListener("click", function() {
            // Find the next sibling element
            videoEl = thumbnail.nextElementSibling;
            
            // Check if the next sibling is a video element
            if (videoEl && videoEl.tagName.toLowerCase() === "video-element") {
                console.log("videoEL: ", videoEl);
                videoEl.play(); // Play the video
                thumbnail.style.display = "none"; // Hide the thumbnail
                videoHeroContent.forEach(function(videoHeroContentEl) {
                    videoHeroContentEl.style.display = "none"; // Hide the content
                });
            }

            // Iterate over content-overlay elements
            videoHeroContentOverlay.forEach(function(videoHeroContentOverlayEl) {
                videoHeroContentOverlayEl.style.cursor = "pointer"
                // Pause video when content overlay is clicked
                videoHeroContentOverlayEl.addEventListener("click", function() {
                    if (videoEl && videoEl.pause) {
                        videoEl.pause(); // Pause the video
                        thumbnail.style.display = "block"; // Show the thumbnail
                        videoHeroContent.forEach(function(videoHeroContentEl) {
                            videoHeroContentEl.style.display = "block"; // Show the content
                        });
                    }
                });
            });
        });
    });

    // Prevent search engines from indexing the Simone Gouw Section
    if (simGouwSection) {
        simGouwSection.setAttribute("data-nosnippet", "");
    }
});